import React from 'react';

export const VoucherIcon = ({
  style,
  className,
}: {
  style?: React.CSSProperties;
  className?: string;
}) => (
  <svg
    width="96px"
    height="96px"
    viewBox="0 0 96 96"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={style}
  >
    <defs>
      <path
        d="M62,28 C62,28.5522847 62.4477153,29 63,29 C63.5522847,29 64,28.5522847 64,28 L82.8722296,28 C84.6552671,28 85.3018396,28.1856512 85.9536914,28.5342654 C86.6055433,28.8828796 87.1171204,29.3944567 87.4657346,30.0463086 C87.8143488,30.6981604 88,31.3447329 88,33.1277704 L88.0004611,43.4158423 C86.23431,44.1872936 85,45.9495025 85,48 C85,50.0504975 86.23431,51.8127064 88.0004611,52.5841577 L88,62.8722296 C88,64.6552671 87.8143488,65.3018396 87.4657346,65.9536914 C87.1171204,66.6055433 86.6055433,67.1171204 85.9536914,67.4657346 C85.3018396,67.8143488 84.6552671,68 82.8722296,68 L64,68 L64,68 C64,67.4477153 63.5522847,67 63,67 C62.4477153,67 62,67.4477153 62,68 L13.1277704,68 C11.3447329,68 10.6981604,67.8143488 10.0463086,67.4657346 C9.39445674,67.1171204 8.88287959,66.6055433 8.53426541,65.9536914 C8.18565122,65.3018396 8,64.6552671 8,62.8722296 L8.00032104,52.583816 C9.76605435,51.8121861 11,50.0501948 11,48 C11,45.9498052 9.76605435,44.1878139 8.00032104,43.416184 L8,33.1277704 C8,31.3447329 8.18565122,30.6981604 8.53426541,30.0463086 C8.88287959,29.3944567 9.39445674,28.8828796 10.0463086,28.5342654 C10.6981604,28.1856512 11.3447329,28 13.1277704,28 L62,28 L62,28 Z M63,63 C62.4477153,63 62,63.4477153 62,64 C62,64.5522847 62.4477153,65 63,65 C63.5522847,65 64,64.5522847 64,64 C64,63.4477153 63.5522847,63 63,63 Z M63,59 C62.4477153,59 62,59.4477153 62,60 C62,60.5522847 62.4477153,61 63,61 C63.5522847,61 64,60.5522847 64,60 C64,59.4477153 63.5522847,59 63,59 Z M63,55 C62.4477153,55 62,55.4477153 62,56 C62,56.5522847 62.4477153,57 63,57 C63.5522847,57 64,56.5522847 64,56 C64,55.4477153 63.5522847,55 63,55 Z M63,51 C62.4477153,51 62,51.4477153 62,52 C62,52.5522847 62.4477153,53 63,53 C63.5522847,53 64,52.5522847 64,52 C64,51.4477153 63.5522847,51 63,51 Z M63,47 C62.4477153,47 62,47.4477153 62,48 C62,48.5522847 62.4477153,49 63,49 C63.5522847,49 64,48.5522847 64,48 C64,47.4477153 63.5522847,47 63,47 Z M63,43 C62.4477153,43 62,43.4477153 62,44 C62,44.5522847 62.4477153,45 63,45 C63.5522847,45 64,44.5522847 64,44 C64,43.4477153 63.5522847,43 63,43 Z M63,39 C62.4477153,39 62,39.4477153 62,40 C62,40.5522847 62.4477153,41 63,41 C63.5522847,41 64,40.5522847 64,40 C64,39.4477153 63.5522847,39 63,39 Z M63,35 C62.4477153,35 62,35.4477153 62,36 C62,36.5522847 62.4477153,37 63,37 C63.5522847,37 64,36.5522847 64,36 C64,35.4477153 63.5522847,35 63,35 Z M63,31 C62.4477153,31 62,31.4477153 62,32 C62,32.5522847 62.4477153,33 63,33 C63.5522847,33 64,32.5522847 64,32 C64,31.4477153 63.5522847,31 63,31 Z"
        id="path-1"
      />
      <filter
        x="-4.4%"
        y="-6.2%"
        width="108.7%"
        height="117.5%"
        filterUnits="objectBoundingBox"
        id="filter-2"
      >
        <feOffset dx="0" dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          stdDeviation="1"
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        />
        <feComposite
          in="shadowBlurOuter1"
          in2="SourceAlpha"
          operator="out"
          result="shadowBlurOuter1"
        />
        <feColorMatrix
          values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.0192034528 0"
          type="matrix"
          in="shadowBlurOuter1"
        />
      </filter>
      <filter
        x="-2.8%"
        y="-3.1%"
        width="105.6%"
        height="111.2%"
        filterUnits="objectBoundingBox"
        id="filter-3"
      >
        <feOffset
          dx="0"
          dy="-0.5"
          in="SourceAlpha"
          result="shadowOffsetInner1"
        />
        <feComposite
          in="shadowOffsetInner1"
          in2="SourceAlpha"
          operator="arithmetic"
          k2="-1"
          k3="1"
          result="shadowInnerInner1"
        />
        <feColorMatrix
          values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.0367679196 0"
          type="matrix"
          in="shadowInnerInner1"
          result="shadowMatrixInner1"
        />
        <feOffset
          dx="0"
          dy="0.5"
          in="SourceAlpha"
          result="shadowOffsetInner2"
        />
        <feComposite
          in="shadowOffsetInner2"
          in2="SourceAlpha"
          operator="arithmetic"
          k2="-1"
          k3="1"
          result="shadowInnerInner2"
        />
        <feColorMatrix
          values="0 0 0 0 0.999901831   0 0 0 0 1   0 0 0 0 0.999879897  0 0 0 0.0915373689 0"
          type="matrix"
          in="shadowInnerInner2"
          result="shadowMatrixInner2"
        />
        <feMerge>
          <feMergeNode in="shadowMatrixInner1" />
          <feMergeNode in="shadowMatrixInner2" />
        </feMerge>
      </filter>
    </defs>
    <g
      id="assets/ma/voucher"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <path
        d="M76.1541722,18 C77.4914503,18 77.9763797,18.1392384 78.4652686,18.4006991 C78.9541574,18.6621597 79.3378403,19.0458426 79.5993009,19.5347314 C79.8607616,20.0236203 80,20.5085497 80,21.8458278 L80,46.1541722 C80,47.4914503 79.8607616,47.9763797 79.5993009,48.4652686 C79.3378403,48.9541574 78.9541574,49.3378403 78.4652686,49.5993009 C77.9763797,49.8607616 77.4914503,50 76.1541722,50 L19.8458278,50 C18.5085497,50 18.0236203,49.8607616 17.5347314,49.5993009 C17.0458426,49.3378403 16.6621597,48.9541574 16.4006991,48.4652686 C16.1392384,47.9763797 16,47.4914503 16,46.1541722 L16,21.8458278 C16,20.5085497 16.1392384,20.0236203 16.4006991,19.5347314 C16.6621597,19.0458426 17.0458426,18.6621597 17.5347314,18.4006991 C18.0236203,18.1392384 18.5085497,18 19.8458278,18 L58,18 L58,18 C58,18.5522847 58.4477153,19 59,19 C59.5522847,19 60,18.5522847 60,18 L76.1541722,18 Z"
        id="Combined-Shape"
        fillOpacity="0.803430944"
        fill="#313934"
        fillRule="nonzero"
        opacity="0.100000001"
      />
      <path
        d="M79.5132009,22 C81.0733587,22 81.6391096,22.1624448 82.20948,22.4674822 C82.7798504,22.7725196 83.2274804,23.2201496 83.5325178,23.79052 C83.8375552,24.3608904 84,24.9266413 84,26.4867991 L84,53.5132009 C84,55.0733587 83.8375552,55.6391096 83.5325178,56.20948 C83.2274804,56.7798504 82.7798504,57.2274804 82.20948,57.5325178 C81.6391096,57.8375552 81.0733587,58 79.5132009,58 L16.4867991,58 C14.9266413,58 14.3608904,57.8375552 13.79052,57.5325178 C13.2201496,57.2274804 12.7725196,56.7798504 12.4674822,56.20948 C12.1624448,55.6391096 12,55.0733587 12,53.5132009 L12,26.4867991 C12,24.9266413 12.1624448,24.3608904 12.4674822,23.79052 C12.7725196,23.2201496 13.2201496,22.7725196 13.79052,22.4674822 C14.3608904,22.1624448 14.9266413,22 16.4867991,22 L60,22 L60,22 C60,22.5522847 60.4477153,23 61,23 C61.5522847,23 62,22.5522847 62,22 L79.5132009,22 Z"
        id="Combined-Shape"
        fillOpacity="0.803430944"
        fill="#313934"
        fillRule="nonzero"
        opacity="0.400000006"
      />
      <g id="Combined-Shape" fillRule="nonzero">
        <use
          fill="black"
          fillOpacity="1"
          filter="url(#filter-2)"
          xlinkHref="#path-1"
        />
        <use fillOpacity="0.803430944" fill="#313934" xlinkHref="#path-1" />
        <use
          fill="black"
          fillOpacity="1"
          filter="url(#filter-3)"
          xlinkHref="#path-1"
        />
      </g>
      <path
        d="M42,50 C45.3137085,50 48,52.6862915 48,56 C48,59.3137085 45.3137085,62 42,62 C38.6862915,62 36,59.3137085 36,56 C36,52.6862915 38.6862915,50 42,50 Z M45,34.8786797 L47.1213203,37 L23,61.1213203 L20.8786797,59 L45,34.8786797 Z M42,53 C40.3431458,53 39,54.3431458 39,56 C39,57.6568542 40.3431458,59 42,59 C43.6568542,59 45,57.6568542 45,56 C45,54.3431458 43.6568542,53 42,53 Z M26,34 C29.3137085,34 32,36.6862915 32,40 C32,43.3137085 29.3137085,46 26,46 C22.6862915,46 20,43.3137085 20,40 C20,36.6862915 22.6862915,34 26,34 Z M26,37 C24.3431458,37 23,38.3431458 23,40 C23,41.6568542 24.3431458,43 26,43 C27.6568542,43 29,41.6568542 29,40 C29,38.3431458 27.6568542,37 26,37 Z"
        id="Combined-Shape"
        fill="#FFFFFF"
        fillRule="nonzero"
        opacity="0.900832403"
      />
    </g>
  </svg>
);
